import React from 'react';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { InfoTooltip } from '@components/main-components/tooltip/InfoTooltip';
import { MediaQuery } from '@context/mediaQuery';
import { LEARN_MORE_SOUND_FEE } from '@utils/constants';

export function SoundFeeTooltip() {
  const { tabletLandscape } = MediaQuery.useContainer();
  return (
    <InfoTooltip delayCloseMs={1500} openOnClick={!tabletLandscape} variant="outlined" size={12}>
      <InfoTooltip.StyledContent className="!p-2 text-center md:!max-w-[240px]">
        This covers Sound's costs for handling operational cost for this transaction.
        <br />
        <AccessibleLink className="underline" absoluteUri={LEARN_MORE_SOUND_FEE} type="external">
          Learn more
        </AccessibleLink>
      </InfoTooltip.StyledContent>
    </InfoTooltip>
  );
}
